"use client";

import { PropsWithChildren, ComponentProps } from "react";
import { useIsShopsite } from "@context/DomainContext";
import { Card as RadixCard, Slot } from "@radix-ui/themes";
import { joinClassNames } from "@utils/helpers";

interface Props {
  sharedClasses?: string;
  shopsiteClasses?: string;
  whitelabelClasses?: string;
}

export default function Card({
  children,
  className = "",
  sharedClasses = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  asChild,
  ref,
  ...restProps
}: ComponentProps<typeof RadixCard> & PropsWithChildren<Props>) {
  const isShopsite = useIsShopsite();

  if (isShopsite) {
    return asChild ? (
      <Slot
        ref={ref}
        className={joinClassNames(className, sharedClasses, shopsiteClasses)}
        {...restProps}
      >
        {children}
      </Slot>
    ) : (
      <div
        ref={ref}
        className={joinClassNames(className, sharedClasses, shopsiteClasses)}
        {...restProps}
      >
        {children}
      </div>
    );
  }

  return (
    <RadixCard
      ref={ref}
      asChild={asChild}
      className={joinClassNames(className, sharedClasses, whitelabelClasses)}
      {...restProps}
    >
      {children}
    </RadixCard>
  );
}
